<template>
  <div id="contenedor-actividad" style="width: 100%;">
    <v-card
      width="100%"
      class="mt-2"
      style="min-height: 150px;"
      elevation="1">
      <v-card-title
        class="pb-2">
        <span>
          {{ $moment(actividad.fecha).format('D/MM/YYYY')}}
        </span>
        <span class="text-caption grey--text text--darken-1 ml-2">
          <fecha-humano
            :fecha="actividad.createdAt">
          </fecha-humano>
        </span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <!-- Frente -->
        <div>
          <h4>
            {{ actividad.frente.descripcion }}
          </h4>
        </div>
        <!-- Descripcion -->
        <cortar-textos
          v-if="actividad.tipo !== 3"
          :texto="actividad.descripcion">
        </cortar-textos>
      </v-card-text>
      <v-card-text
        v-if="actividad.imagenes && actividad.imagenes.length > 0"
        class="pt-0">
        <v-row
          dense>
          <!-- Imagenes -->
          <template
            v-for="imagen in actividad.imagenes">
            <template>
              <v-col
                cols="auto"
                :key="imagen">
                <v-img
                  :src="`${$urlFileServer}/${imagen}/thumbnail`"
                  :lazy-src="`${$urlFileServer}/${imagen}/thumbnail`"
                  height="50"
                  width="50"
                  contain
                  class="blue-grey darken-4"
                  style="cursor: pointer;"
                  @click="mostrarImagenes(actividad)">
                </v-img>
              </v-col>
            </template>
          </template>
        </v-row>
      </v-card-text>
      <!-- Acciones -->
      <v-card-actions>
        <v-chip
          v-if="actividad.esProblema"
          color="warning">
          <v-icon
            small
            left>
            mdi-alert-outline
          </v-icon>
          con detalle
        </v-chip>
        <v-spacer></v-spacer>
        <!-- Editar actividad -->
        <v-btn
          icon
          @click="editar(actividad)">
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
        <!-- Borrar actividad -->
        <v-btn
          icon
          @click="borrar(actividad)">
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import CortarTextos from '@/components/CortarTextos.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'CardListadoActividades',
  components: {
    CortarTextos,
    FechaHumano,
  },
  props: {
    actividad: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    getTipo(tipo) {
      if (!tipo) return '';
      switch (tipo) {
        case 1:
          return 'diario';
        case 2:
          return 'informes';
        case 3:
          return 'album';
        default:
          return '';
      }
    },
    mostrarImagenes(actividad) {
      const imagenes = actividad.imagenes
        .map((img) => ({
          url: `${this.$urlFileServer}/${img}`,
          titulo: `${actividad.contrato.numero}_${this.$moment(actividad.fecha).format('D-MM-YYYY')}_${this.getTipo(actividad.tipo)}`,
        }));
      eventBus.$emit('mostrar-imagenes-actividad-contrato', imagenes);
    },
    editar(actividad) {
      eventBus.$emit('editar-actividad-contrato', actividad);
    },
    borrar(actividad) {
      eventBus.$emit('eliminar-actividad-contrato', actividad);
    },
  },
};
</script>

<style lang="scss">

</style>
